export default "__VITE_ASSET__CRN2sW80__"